// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1qIzj","right":"Footer_right__2GPno","buttons":"Footer_buttons__1MyY9"};